import {
  apiRequest,
  P3KlistCP3K,
} from "../../../../../services/adapters/kepegawaian/P3KService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      P3KlistCP3K,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default DataTableRepository;
